import { Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function NotFoundPage() {
  return (
    <section className="mx-auto" style={{ maxWidth: '640px' }}>
      <Card className="glass-card text-light text-center">
        <Card.Body>
          <h1 className="section-title mb-3">Page Not Found</h1>
          <p className="text-muted-soft">The page you requested does not exist.</p>
          <Button as={Link} to="/" className="cta-btn">
            Return Home
          </Button>
        </Card.Body>
      </Card>
    </section>
  );
}

export default NotFoundPage;
